/**
 * @file CardFeatured/constants.js
 * @copyright 2016 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const DEFAULT_IMAGE_SIZES = [
    `(max-width: 640px) 99vw`,
    `(max-width: 960px) 47vw`,
    `310px`,
];
